export default "__VITE_ASSET__15e070c8__"